import { Component, Inject, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { LangChangeEvent, TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { FormField } from '../form-field.component';
import { FormFieldError } from '../uix-forms.utils';
import { MatIcon } from '@angular/material/icon';
import { AutoUnsubscribe } from '../../auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  imports: [ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatDatepickerModule, TranslatePipe, MatIcon],
  selector: 'app-form-field-date',
  templateUrl: './form-field-date.component.html',
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
  ],
  standalone: true,
})
export class FormFieldDateComponent extends FormField {
  @Input()
  minValue: string | Date;

  @Input()
  maxValue: string | Date;

  protected readonly langSub: Subscription;

  constructor(
    protected readonly adapter: DateAdapter<unknown>,
    @Inject(MAT_DATE_LOCALE) protected locale: string,
    protected readonly translate: TranslateService,
  ) {
    super();

    this.langSub = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.locale = event.lang;
      this.adapter.setLocale(this.locale);
    });

    this.locale = this.translate.currentLang;
    this.adapter.setLocale(this.locale);
  }

  // Only displays the first error in Mat-error.
  displayedErrors(): FormFieldError[] {
    return this.errors
      .filter((e: FormFieldError) => {
        return this.formGroup.controls[this.field].hasError(e.error);
      })
      .slice(0, 1);
  }
}
